
import BaseModel from "./BaseModel";

class CostSpecificationRow extends BaseModel {
  id: number;
  bookingsExternalId: number;
  label: string;
  // rawValue: number;
  // rawCostExVat: number;
  // rawCostVat: number;
  // rawCostVatFraction: number;
  formattedValue: string;
  unit: string;
  rowType: RowType;
  paymentStage: PaymentStage;

  constructor(data) {
    super(data, []);
    this.id = data.id;
    this.bookingsExternalId = data.bookingsExternalId;
    this.label = data.label;
    this.formattedValue = data.formattedValue;
    this.unit = data.unit;
    this.rowType = data.rowType;
    this.paymentStage = data.paymentStage
  }
}

export enum RowType {
  COST_SEK_INC_VAT = "COST_SEK_INC_VAT",
  DISTANCE_KM = "DISTANCE_KM",
  INFO = "INFO",
}

export enum PaymentStage {
  INITIAL = "initial",
  RETURN = "return",
}


export default CostSpecificationRow;
